import { globalConstants, managerProfileConstants } from "../../constants/";

const { SUCCESS } = globalConstants;
const { MANAGERS_DETAIL, PAGINATED_MANAGERS_DATA } = managerProfileConstants;

const initialState = {
  allLocations: [],
  managerDetails: [],
  collectiveData: {},
  managerDataPagination: {
    size: 10,
    number: -1,
    totalElements: 0,
  },
};

export const managerProfileReducer = (state = initialState, action) => {
  switch (action.type) {
    case MANAGERS_DETAIL + SUCCESS:
      return { ...state, managerDetails: action.data };
    case PAGINATED_MANAGERS_DATA + SUCCESS:
      return {
        ...state,
        allLocations: action.data.pageData,
        managerDataPagination: action.data.page,
        collectiveData: action.data.componentData,
      };
    default:
      return state;
  }
};
